module.exports = __webpack_public_path__ + "static/media/icon-event__caida-del-comunismo.c9d91912.svg";